// src/stone/illustrations/StonjiPercentIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPercentIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h96v96H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M15 17.998a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M69 29.997a2.997 2.997 0 1 0 0-5.995 2.997 2.997 0 0 0 0 5.995M27.005 71.997a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M80.999 17.998a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M80.999 12.004H15v5.989h65.998z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M66.884 24.884 24.882 66.886l4.231 4.23 42.002-42.001z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M15 83.996a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994M80.999 83.996a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M80.999 78.007H15v5.99h65.998z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M68.974 53.962a9.018 9.018 0 1 0 0 18.036 9.018 9.018 0 0 0 0-18.036m0 11.967a2.965 2.965 0 1 1-.01-5.93 2.965 2.965 0 0 1 .01 5.93M27.015 24.008a9.017 9.017 0 1 0 0 18.035 9.017 9.017 0 0 0 0-18.035m0 11.967a2.965 2.965 0 1 1-.011-5.93 2.965 2.965 0 0 1 .011 5.93"
        }
      )
    ]
  }
);
var StonjiPercentIllustration_default = StonjiPercentIllustration;

export {
  StonjiPercentIllustration,
  StonjiPercentIllustration_default
};
